export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/v1/auth/login',
    VERIFY: '/api/v1/auth/verify',
    LOGOUT: '/api/v1/auth/logout'
  },
  STORES: {
    LIST: '/api/v1/stores',
    DETAILS: () => '/api/v1/stores'
  },
  ORDERS: {
    LIST: (customerId, market) => `/api/v1/stores/${customerId}/orders${market ? `?market=${market}` : ''}`,
    DETAILS: (orderNumber, market, customerId) => `/api/v1/orders/${orderNumber}/details?market=${market}&customer_id=${customerId}`,
    MODIFY: (customerId, orderId) => `/api/v1/stores/${customerId}/orders/${orderId}`,
    STANDING: (customerId, market) => `/api/v1/stores/${customerId}/standing-orders?market=${market}`,
    PRODUCTS: (customerId, market) => `/api/v1/products/customer/${customerId}?market=${market}`,
    HISTORY: (customerId) => `/api/v1/stores/${customerId}/history`,
  },
  VERSION: {
    COMBINE: '/api/v1/version/combine'
  }
};
